<template>
  <div style="padding: 10px">
    <el-card
      v-for="(item, index) in message.data.content"
      :key="index"
      :body-style="{ padding: '0px' }"
      style="margin-bottom: 10px"
      class="compact-container"
    >
      <div class="compact-content">
        <div
          v-if="itemImage(item)"
          :style="imageStyle(item)"
          class="image"
          style="background-position: center; background-size: cover"
          @click="$emit('setLightBoxImage', item.image)"
        />
        <div style="padding: 8px" class="content" :style="isUiBetaEnabled && backgroundStyle">
          <span
            class="kr-title"
            v-text="item.text"
            style="word-break: break-word"
            :style="isUiBetaEnabled && titleStyle"
          />

          <div style="margin: 4px 0">
            <div
              v-if="
                !shouldShowFullContent[index] &&
                readMoreEnabled &&
                item.subtext?.length > readMoreCharacterCount
              "
            >
              <span
                class="subtext"
                style="word-break: break-word; white-space: pre-line"
                v-html="truncateText(item.subtext)"
              ></span>
              <div
                class="keyreply-read-more"
                @click="setShowFullContent(index)"
                :style="{
                  color: settings.agentTextColor,
                  fontWeight: '600',
                  fontStyle: 'italic',
                }"
              >
                Read More
              </div>
            </div>
            <span
              v-else
              class="subtext"
              style="word-break: break-word; white-space: pre-line"
              v-html="item.subtext"
            ></span>
          </div>
          <div
            v-for="(button, buttonIndex) in item.buttons"
            :key="buttonIndex"
            style="text-align: center; display: block"
            class="compact-button"
          >
            <el-button
              v-if="
                !((button.type && button.type === 'website') || button.url) ||
                isDisabledButton(button)
              "
              class="kr-button"
              :class="{ 'blue-button': buttonOutline === 'primary' }"
              v-text="button.text"
              size="small"
              target="_blank"
              style="width: 100%; margin-bottom: 8px"
              :type="buttonOutline"
              :plain="true"
              :disabled="isDisabledButton(button)"
              @click.stop.prevent="onClick($event, button)"
            />
            <a v-else :href="validUrl(button.url)" :target="button.popup ?? '_blank'">
              <el-button
                class="kr-button"
                :class="{ 'blue-button': buttonOutline === 'primary' }"
                v-text="button.text"
                size="small"
                target="_blank"
                style="width: 100%; margin-bottom: 8px"
                :type="buttonOutline"
                :plain="true"
                @click="onClick($event, button)"
              />
            </a>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import _ from "lodash";
import isDisabledButton from "@/helpers/isDisabledButton";
import validUrl from "@/helpers/validUrl";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      shouldShowFullContent: {},
    };
  },
  props: ["message", "buttonOutline", "shouldDisableIfInLivechat", "backgroundStyle", "titleStyle"],
  methods: {
    validUrl,
    imageStyle(item) {
      return {
        backgroundSize: _.get(item, "options.padded") ? "contain" : "cover",
        backgroundImage: `url("${this.itemImage(item)}")`,
      };
    },
    isDisabledButton(button) {
      return isDisabledButton(this, button);
    },
    itemImage(item) {
      const image = item.image || _.get(item, "images[0]");
      return image;
    },
    onClick($event, button) {
      const _button = {
        ...button,
        $event,
      };
      this.$emit("sendPostback", _button);
    },
    truncateText(text) {
      if (!text) return "";
      return text.slice(0, this.readMoreCharacterCount) + "...";
    },
    setShowFullContent(index) {
      this.$set(this.shouldShowFullContent, index, true);
    },
  },
  computed: {
    ...mapGetters(["isUiBetaEnabled"]),
    settings() {
      return this.$store.getters.settings;
    },
    readMoreCharacterCount() {
      return this.settings.readMoreConfigure.readMoreCharacterCount;
    },
    readMoreEnabled() {
      return this.settings.readMoreConfigure.enabled;
    },
  },
};
</script>

<style lang="scss" scoped>
.ui-beta {
  .compact-container {
    border-radius: 16px;
    overflow: hidden;

    .compact-content {
      display: flex;
    }
    .compact-button {
      text-align: left;
      width: 100%;
      margin-top: 20px;

      .kr-button {
        padding: 8px;
        white-space: normal !important;
        line-height: 18px;
      }
    }
  }

  .image {
    max-width: 200px;
    width: 40%;
  }
  .content {
    flex: 1;
    background: #dce2f5;

    .kr-title {
      color: #4e6cce;
      font-size: 16px;
      font-weight: 600;
    }

    .subtext {
      font-size: 16px;
      color: #333;
    }
  }
  .kr-button {
    padding: 5px;
    border-radius: 8px;

    &.blue-button {
      border: 1px solid #4e6cce;
      color: #4e6cce;
      background: #fff;

      &:hover {
        color: #fff;
        background: #4e6cce;
      }
    }
  }
}
</style>
